import React from 'react';
import {
  BrandImage,
  Card,
  CardDetails,
  CardInfos,
  CardInfosContainer,
  CardNumber,
  CardOwner,
  TaxDetails,
  TaxLabel,
  TaxValue,
} from './styles';
import { UserCreditCardsDTO } from '../../../dtos/UserCreditCardsDTO';
import { ParcelasDTO } from '../../../dtos/ParcelasDTO';
import { useHelpers } from '../../../context/helpers';

interface Props {
  card?: UserCreditCardsDTO;
  tax?: ParcelasDTO;
}

export default function CardPreview({ card, tax }: Props) {

  const { formatNumberToLocaleAmount } = useHelpers();

  return (
    <Card>
      {card && (
        <>
          <CardInfosContainer>
            <BrandImage
              source={{
                uri: card.icon,
              }}
            />

            <CardDetails>
              {card.name && <CardOwner>{card.name}</CardOwner>}
              <CardInfos>
                <CardNumber>**** **** **** {card.number.slice(-4)}</CardNumber>
                <CardNumber>{card.expiration}</CardNumber>
              </CardInfos>
            </CardDetails>
          </CardInfosContainer>
        </>
      )}
      {tax && (
        <>
          <TaxDetails hasCard={!!card}>
            <TaxLabel>Valor final</TaxLabel>

            <TaxValue>
              {formatNumberToLocaleAmount(tax.valorCompraTaxa)}
            </TaxValue>
          </TaxDetails>
          <TaxDetails>
            <TaxLabel>Taxa</TaxLabel>

            <TaxValue>
              {tax.CET.toFixed(2).replace('.', ',') + '%'} ao mês
            </TaxValue>

          </TaxDetails>

        </>
      )}

    </Card>
  );
}
